<!-- 人事费用申请表 -->
<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'

	import {
		initWxConfig
	} from "../api/jssdk.js";
	import stringUtils from "../assets/js/stringUtil.js";
	import {
			formatDate
		} from '@/utils/date'
	import {getRelation} from "../api/employee.js";

	var templateData = {
		TemplateContent: {
			Controls: []
		}
	};
	
	const sendMessagetTemplate = {
		title: null,
		url: null,
		toUser: [],
		desc: null,
		template: null,
	};
	var logInfo = null;
    import { submitProcess,sendMessage } from '@/api/approval'
	var isSubmit = false;

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				"templateData": templateData,
				isDisabled: false,
				templateId: "",
				spNo: null,
				sendMessageData: Object.assign({}, sendMessagetTemplate),
				flowId:null
			}
		},
		mounted() { //页面挂载
			initWxConfig(this);
			logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.getTemplate();
			this.spNo = this.$route.query.spNo;
			this.flowId = this.$route.query.flowId;
		},
		methods: { //方法
			clickChoose(dataVal, name) {
				var that=this;
				
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "multi", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var users = res.result.userList; // 已选的部门列表
						var controls = that.templateData.TemplateContent.Controls.filter(e => {
							return e.Property.Title[0].Text == '审批人员';
						})[0];
						controls.Values = [];
						controls.Value = '';
						users.forEach((e,index) =>{
							controls.Values.push([e.id, e.name]);
							if (index == users.length - 1) {
								controls.Value += e.name;
							} else {
								controls.Value += e.name + ',';
							}
						})
					}
				})
			},
			getTemplate:async function(){
				var fullName = logInfo.fullName;
				// if (fullName.indexOf("招聘部") == -1 && fullName.indexOf("综合事务部") == -1 && logInfo.EmpNo != 'SC18007058') {
				// 	this.Message({
				// 		message: '没有申请权限',
				// 		type: 'error',
				// 		duration: 1000
				// 	});
				// 	this.isDisabled = true;
				// }

				let that = this;

				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + stringUtils.GetQueryString("templateId"),
					method: "get",
				}).then(async res => {
					if (res.data == null || res.data.ErrCode != 0) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '模板获取错误'
						});
						return;
					}
					that.templateData = res.data.Body;
					if (that.templateData == null) {
						alert("模板获取错误");
						return;
					}
					for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
						if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.InCompanyDate;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.Mobile;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "流程条件") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.JobLevel <= 4 ? 1 : 2;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
							let date = new Date();
							that.templateData.TemplateContent.Controls[i].Value = formatDate(date,"yyyy-MM-dd");
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "端口费用承担部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
						}else if(that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "审批人员"){
							that.templateData.TemplateContent.Controls[i].IsShow = false
							that.templateData.TemplateContent.Controls[i].Property.Require = 0;
						}
					}
					this.templateData = this.assignControl(that.templateData, logInfo);
					this.templateData = await this.assignControlBySpNo(that.templateData,null, this.flowId);
					if(this.flowId!=null){
						stringUtils.setAddIsShow(false);
						this.templateData.TemplateContent.Controls.forEach(e =>{
							if(e.Property.Control == 'Table'){
								this.$set(e,'addIsShow',false)
								this.$set(e,'deleteIsShow',false);
								e.Config.Table.Children.forEach(children =>{
									children.Disable = true;
								})
							}
							if(e.Property.Title[0].Text != '审批人员'){
								e.Disable = true;
							}
						})
					}
				}, err => {
					console.log(err)
				});
			},
			getTextVal() {
				console.log(this.templateData)
			},
			getSelectorVal(val, name) {
				var type = "";
				var y = 0;
				var children = "";
				if (name == "岗位职责") {
					var controls = this.templateData.TemplateContent.Controls;
					for (var i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text == name) {
							var options = controls[i].Config.Selector.Options;
							for (var j = 0; j < options.length; j++) {
								if (options[j].Key == val) {
									type = options[j].Value[0].Text;
								}
							}
						} else if (controls[i].Property.Title[0].Text == "调整内容") {
							if (type == "有调整") {
								// controls[i].IsShow = true;
								this.$set(controls[i], 'IsShow', true)
								children = controls[i].Config.Table.Children;
								for (y = 0; y < children.length; y++) {
									if (children[y].Value == null) {
										children[y].Value = '';
									} else {
										children[y].Value = null;
									}
								}
							} else if (type == "无调整") {
								// controls[i].IsShow = false;
								this.$set(controls[i], 'IsShow', false)
								children = controls[i].Config.Table.Children;
								for (y = 0; y < children.length; y++) {
									if (children[y].Value == null) {
										children[y].Value = '';
									} else {
										children[y].Value = null;
									}
									children[y].Values = null;
								}
							}
						}
					}
				}
				this.$forceUpdate()
			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit:async function() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control1.Value ,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请性质"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var NameOfData = "";
				for (var i = 0; i < control2.Config.Selector.Options.length; i++) {
					var data = control2.Config.Selector.Options[i];
					if(data.Key ==control2.Value){
						NameOfData = data.Value[0].Text;
					}
				}
				info.SummaryInfo.push({"Text":"申请性质："+NameOfData,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "预计总费用(元)"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"预计总费用(元)："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				this.templateData.SummaryList=SummaryList;
				
				this.formLoading = true;
				
				var users = [];
				this.templateData.TemplateContent.Controls.forEach(e =>{
					if(e.Property.Title[0].Text.indexOf("费用分摊")>-1 ){
						e.Config.Table.Children.forEach( t => {
							if(t.Property.Title[0].Text == "部门选项"){
								t.Config.Selector.Options.forEach(option =>{
									if(option.Key == t.Value){
										if(option.Value[0].Text == '工商铺部'){
											users.push(["SC16006360","覃斌"])
										}else if(option.Value[0].Text == '二级市场'){
											users.push(["SC23000441","陈相云"])
										}else if(option.Value[0].Text == '房友圈'){
											users.push(["SC24000022","汪净"])
										}else if(option.Value[0].Text == '汇瀚'){
											users.push(["SC04110010","杨小玉"])
										}
									}
								})
							}
						})
					}
				})
				if(users.length == 0){
					users.push(["SC24000029","钟志斌"])
				}
				this.templateData.TemplateContent.Controls.forEach(e => {
					if(e.Property.Title[0].Text == "审批人员"){
						e.Values = users;
					}
				})
				//提交
				submitProcess(this.templateId, logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					this.formLoading = false;
				});
				this.formLoading = false;
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
